/* eslint-disable */
module.exports = function (document, window, undefined) {
    function setDisplay (dom, show) {
        if (!dom) {
            console.error('dom is undefined');
            return 0;
        }
        dom.style.display = show;
    }
    function getWidth(dom) {
        if (!dom) {
            console.error('dom is undefined');
            return 0;
        }
        return parseInt(document.defaultView.getComputedStyle(dom, null).width, 10);
    }
    function getHeight(dom) {
        if (!dom) {
            console.error('dom is undefined');
            return;
        }
        return parseInt(document.defaultView.getComputedStyle(dom, null).height, 10);
    }
    function setWidth(dom, width) {
        dom.style.width = addPx(width);
    }

    function setHeight(dom, height) {
        dom.style.height = addPx(height);
    }
    function addPx(number) {
        if (number === undefined) {
            console.error('number is undefined');
            return;
        }
        return number + 'px';
    }
    function showDom(dom) {
        dom.style.display = 'block';
    }
    function hideDom(dom) {
        dom.style.display = 'none';
    }
    function makeInvisible(dom, len) {
        if (len <= 1) {
            dom.style.visibility = 'hidden';
        } else {
            dom.style.visibility = 'visible';
        }
    }

    var Keyboard = (function () {
        function Keyboard() {

        }
        var keyMap = {
            esc: 27,
            '←': 37,
            '→': 39
        }
        Keyboard.mappingObj = {};
        Keyboard.bind = function (key, handler) {
            var func = function (event) {
                if (keyMap[key] === event.keyCode) {
                    event.preventDefault();
                    handler();
                }
            }
            document.addEventListener('keydown', func);
            Keyboard.mappingObj[key] = func;
        }
        Keyboard.unbind = function (keys) {
            var keyArray = [].slice.call(arguments);
            for (var i = 0; i < keyArray.length; i++) {
                document.removeEventListener('keydown', Keyboard.mappingObj[keyArray[i]]);
            }
            Keyboard.mappingObj = {};
        }
        return Keyboard;
    })();

    var PhotoMousedown, PhotoMouseup, PhotoMousemove, PhotoZoomChanged;

    var Photo = (function () {
        function Photo(data, photoDom, photoContainerDom, parent) {
            this.zoomRatio = 1;
            this.zoomText = parent.dom.querySelector('.zoom-number');
            this.url = data.src;
            this.title = data.title;
            this.description = data.description || '';
            this.iconurl = data.littleTag || '';
            this.dom = photoDom;
            this.container = photoContainerDom;
            this.parentdom = parent.dom;

            this.offsetX = 0;
            this.offsetY = 0;
            this.isMouseDown = false;
            this.inited = false;
            this.zoomInBtn = parent.zoomInBtn;
            this.zoomOutBtn = parent.zoomOutBtn;
            this.initZoomRatio = 1;
            this.maxZoomRatio = this.initZoomRatio * 5;
            this.minZoomRatio = this.initZoomRatio * 0.1;
            this.canDragShowed = false;
            this.photoGallery = parent;
            this.initialWidth = 0;
            this.initailHeight = 0;
            this.preloadImage = null;
            // 鼠标位置
            this.x;
            this.y;
            var event1 = document.createEvent('Event');
            event1.initEvent('zoomChanged', true, true);

            this.eventMapping = {
                zoomChanged: event1
            };
            this.oldNewZoomValue = {};
        }
        Photo.step = 0.5;
        Photo.stepMultiply = 1.4;

        Photo.prototype.zoomIn = function () {

            if(this.zoomRatio >= this.maxZoomRatio) {
                return;
            }

            var oldZoomRatio = this.zoomRatio;
            this.zoomRatio += 0.2;
            this.zoomRatio = Math.round(this.zoomRatio*100)/100;

            if (this.zoomRatio >= this.maxZoomRatio && oldZoomRatio < this.maxZoomRatio) {
                this.zoomRatio = this.maxZoomRatio;
            }
            // this.zoomRatio *= Photo.stepMultiply;

            this.trigger('zoomChanged', this.zoomRatio, oldZoomRatio);
        };

        Photo.prototype.zoomOut = function () {
            if (this.zoomRatio <= this.minZoomRatio) {
                return;
            }

            var oldZoomRatio = this.zoomRatio;
            this.zoomRatio -= 0.2;
            this.zoomRatio = Math.round(this.zoomRatio*100)/100;

            if (oldZoomRatio > this.minZoomRatio && this.zoomRatio <= this.minZoomRatio) {
                this.zoomRatio = this.minZoomRatio;
            }

            // this.zoomRatio /= Photo.stepMultiply;
            this.trigger('zoomChanged', this.zoomRatio, oldZoomRatio);
        };
        Photo.prototype.download = function (event) {
            // window.open(this.url);
            // window.location = this.url;

            // for ie and safari
            var a = document.createElement('a');
            if (typeof a.download === "undefined") {
                console.log('not support download attribute');
                // event.preventDefault();
                // window.open(this.url);
            }
        };
        Photo.prototype.trigger = function (event, newVal, oldVal) {
            this.container.dispatchEvent(this.eventMapping[event]);
            this.oldNewZoomValue = { newVal: newVal, oldVal: oldVal };
        };
        Photo.prototype.init = function () {
            var self = this;

            if (this.inited) {
                this.zoomRatio = 1;
            }
            this.offsetX = 0;
            this.offsetY = 0;

            this.inited = true;

            Object.assign(this.dom.style, this.dom.style, {
                position: 'absolute',
                left: 0,
                top: 0
            });
            this.changeSrc();

            function onLoad() {
                self.draw();
                self.dom.removeEventListener('load', onLoad);
            };

            this.dom.addEventListener('load', onLoad);

        };
        Photo.prototype.preload = function () {
            if (!this.preloadImage) {
                this.preloadImage = new Image();
            }
            this.preloadImage.src = this.url;
        }
        Photo.prototype.destroy = function () {
            // destroy
            this.dom.removeEventListener('mousedown', PhotoMousedown);
            document.removeEventListener('mouseup', PhotoMouseup);
            document.removeEventListener('mousemove', PhotoMousemove);
            this.container.removeEventListener('zoomChanged', PhotoZoomChanged);
        };

        Photo.prototype.changeSrc = function () {
            this.dom.src = this.url;
            //this.photoGallery.dom.querySelector('.download a').href = this.url;
        };
        Photo.prototype.draw = function () {

            this.initSize();
            this.initStyle();
            this.initBind();

            this.trigger('zoomChanged', this.initZoomRatio, this.initZoomRatio);

        };

        Photo.prototype.initSize = function () {
            var width = this.dom.naturalWidth;
            var height = this.dom.naturalHeight;
            var domHeight = getHeight(this.parentdom);
            var domWidth = getWidth(this.parentdom);
            var imgHeight = domHeight - 72 * 2;
            if (imgHeight <= 200) {
                imgHeight = 200;
            }
            var imgWidth = imgHeight / 3 * 4;
            this.initialWidth = imgWidth;
            this.initialHeight = imgHeight;
            setWidth(this.dom, this.initialWidth);
            setHeight(this.dom, this.initialHeight);
         };

        Photo.prototype.initStyle = function () {
            Object.assign(this.container.style, {
                position: 'relative',
                overflow: 'hidden'
            });
            Object.assign(this.dom.style, {
                position: 'absolute',
                left: 0,
                top: 0
            });

            // 定位置
            this.makePosition();
        };

        Photo.prototype.makePosition = function () {

            var zoomRatio = this.zoomRatio;

            // dom.width()是不计算transform的倍率的。
            var width = getWidth(this.dom);
            var height = getHeight(this.dom);

            var containerWidth = getWidth(this.container);
            var containerHeight = getHeight(this.container);

            var limitWidth = 0.5 * (-containerWidth + width * zoomRatio);
            var limitHeight = 0.5 * (-containerHeight + height * zoomRatio);

            function makePositionByOffSet(inner, outer, offset) {
                // 这个函数是不管offset的合理性的
                if (!inner.width && !inner.height) {
                    return;
                }
                if (!outer.width && !outer.height) {
                    return;
                }
                if (offset.x === undefined || offset.y === undefined) {
                    return;
                }
                var left, top;
                left = (outer.width - inner.width) / 2 + offset.x;
                top = (outer.height - inner.height) / 2 + offset.y;
                if(left > outer.width) {
                    left = 0 -left/2;
                }
                if(top > outer.height) {
                    top = 0 - top/2;
                }
                return {
                    left: left,
                    top: top
                }
            }

            // 不能超过container的边界
            function sgn(x, y) {
                //
                y = Math.abs(y);
                if (x < -y) {
                    return -y;
                } else if (-y <= x && x <= y) {
                    return x;
                } else {
                    return y;
                }
            }

            // 不再限制外框
            // this.offsetX = sgn(this.offsetX, limitWidth);
            // this.offsetY = sgn(this.offsetY, limitHeight);


            // 注意无论scale多少，绝对定位时还是以原始大小来定的！
            var style = makePositionByOffSet({
                width: width, // 这里不乘zoomRatio！
                height: height
            }, {
                    width: containerWidth,
                    height: containerHeight
                }, {
                    x: this.offsetX,
                    y: this.offsetY
                });

            // 需要dom是绝对定位
            Object.assign(this.dom.style, {
                left: addPx(style.left),
                top: addPx(style.top)
            });
        };

        Photo.prototype.onMousedown = function (event) {
            // 什么都不做
            if (event.which !== 1) {
                return;
            }

            this.x = event.pageX;
            this.y = event.pageY;

            this.isMouseDown = true;
            event.preventDefault();

        };

        Photo.prototype.onMouseup = function (event) {
            this.isMouseDown = false;
            event.preventDefault();
        };

        Photo.prototype.onMousemove = function (event) {
            // 如果不是点击时的鼠标移动，什么都不做
            // 或者当zoomRatio === 1的时候 什么都不做
            if (!this.isMouseDown) {
                return;
            }
            if (this.zoomRatio === 1) {
                return;
            }
            event.preventDefault();

            var dx = event.pageX - this.x;
            var dy = event.pageY - this.y;

            this.offsetX += dx;
            this.offsetY += dy;

            this.makePosition();

            this.x = event.pageX;
            this.y = event.pageY;

        };

        Photo.prototype.onZoomChanged = function (event) {
            // 以下代码保证放大的是中心区域

            var xRatio = this.offsetX / getWidth(this.dom);
            var yRatio = this.offsetY / getHeight(this.dom);

            this.zoomText.innerHTML = Math.round(this.zoomRatio * 100) + '%';

            setWidth(this.dom, this.initialWidth * this.zoomRatio);
            setHeight(this.dom, this.initialHeight * this.zoomRatio);
            // alert(this.offsetX);
            var diffX = xRatio * getWidth(this.dom) / this.zoomRatio - this.offsetX;
            var diffY = yRatio * getHeight(this.dom) / this.zoomRatio - this.offsetY;

            this.offsetX += diffX;
            this.offsetY += diffY;

            // ends
            this.makePosition();

            this.dom.classList.remove('panning');
            this.zoomInBtn.classList.remove('disabled');
            this.zoomOutBtn.classList.remove('disabled');

            if (this.zoomRatio > 1) {
                this.dom.classList.add('panning');
                if (!this.canDragShowed) {
                    this.showCanDrag();
                }
            }

            if (this.zoomRatio >= this.maxZoomRatio) {
                this.zoomInBtn.classList.add('disabled');
            }

            if (this.zoomRatio <= this.minZoomRatio) {
                this.zoomOutBtn.classList.add('disabled');
            }
            if (this.zoomRatio === 1) {
                this.resize();
            }
        };

        Photo.prototype.initBind = function () {
            PhotoMousedown = this.onMousedown.bind(this);
            PhotoMouseup = this.onMouseup.bind(this);
            PhotoMousemove = this.onMousemove.bind(this);
            PhotoZoomChanged = this.onZoomChanged.bind(this);

            this.dom.addEventListener('mousedown', PhotoMousedown);
            document.addEventListener('mouseup', PhotoMouseup);
            document.addEventListener('mousemove', PhotoMousemove);
            this.container.addEventListener('zoomChanged', PhotoZoomChanged);
        };

        Photo.prototype.resize = function () {
            this.offsetX = 0;
            this.offsetY = 0;
            this.initSize();
            this.initStyle();
        };

        Photo.prototype.showCanDrag = function () {
            var canDragLabel = this.photoGallery.dom.querySelector('.dc-photo-can-drag-label');
            canDragLabel.classList.remove('transparent');
            this.canDragShowed = true;
            setTimeout(function () {
                canDragLabel.classList.add('transparent');
            }, 1000);
        };

        return Photo;
    })();

    var PhotoGalleryDestroy, PhotoGalleryPrev, PhotoGalleryNext, PhotoGalleryZoomIn, PhotoGalleryZoomOut;
    var PhotoGalleryPhotoChanged, PhotoGalleryWindowResize, PhotoGalleryResize;

    var PhotoGallery = (function () {
        function PhotoGallery(dom, data, index) {
            if (!dom || dom.length === 0) {
                throw Error('没找到dom哦');
            }
            if (!data) {
                throw Error('你的数据呢');
            }
            if (index >= data.length || index <= -1) {
                throw Error('你index传错了亲');
            }
            this.dom = dom;
            this.data = data;
            this.photoContainerDom = this.dom.querySelector('.sue-photogallery-container');
            this.containerParent = this.dom.querySelector('.pageWrapper');
            this.photoDom = this.dom.querySelector('#containerimg');
            this.leftBtn = this.dom.querySelector('.leftArrowArea');
            this.rightBtn = this.dom.querySelector('.rightArrowArea');
            this.zoomBtn = this.dom.querySelector('.actionButtons');
            this.closeBtn = this.dom.querySelector('.close');
            this.zoomInBtn = this.dom.querySelector('.zoomIn');
            this.zoomOutBtn = this.dom.querySelector('.zoomOut');
            this.arrowContainer = this.dom.querySelectorAll('.arrowContainer');
            //this.downloadBtn = this.dom.querySelector('.download');

            this.notitle = this.dom.querySelector('.notitle');
            this.onlytitle = this.dom.querySelector('.onlytitle');
            this.titledescrip = this.dom.querySelector('.title-descrip');
            this.indexDom = this.dom.querySelectorAll('.index');
            this.photoNameDom = this.dom.querySelectorAll('.photoName');
            this.photoDescription = this.dom.querySelector('.discription');
            this.littleTag = this.dom.querySelectorAll('.myicon img');
            this.littleTagContainer = this.dom.querySelectorAll('.myicon');

            this.index = index;
            this.photoLength = this.data.length;
            this.photos = [];
            this.currentPhoto = null;
            this.onClose = function () { };
            this.onOpen = function () { };

            var event1 = document.createEvent('Event');
            event1.initEvent('photoChanged', true, true)
            var event2 = document.createEvent('Event');
            event2.initEvent('windowResize', true, true)
            this.eventMapping = {
                photoChanged: event1,
                windowResize: event2
            };
            // 第一次inited后设为true
            this.inited = false;

            this.previousPhoto = null;
            this.nextPhoto = null;
        }
        PhotoGallery.prototype.getIndex = function (type) {
            var result;
            if (type === 'next') {
                if (this.index !== this.photoLength - 1) {
                    result = this.index + 1;
                } else {
                    result = 0;
                }
            }
            if (type === 'prev') {
                if (this.index !== 0) {
                    result = this.index - 1;
                } else {
                    result = this.photoLength - 1;
                }
            }
            return result;
        };
        PhotoGallery.prototype.drawBack = function () {
            var domHeight = getHeight(this.dom);
            var domWidth = getWidth(this.dom);
            var imgHeight = domHeight - 72 * 2;
            if (imgHeight <= 200) {
                imgHeight = 200;
            }
            var imgWidth = imgHeight / 3 * 4;
            var containerleft = (domWidth - imgWidth) / 2;
            var leftBtnLeft = containerleft - getWidth(this.leftBtn) - 40;

            var leftBtnTop = 72 + imgHeight / 2  -18 ;
            var zoomBtnTop = imgHeight + 20 + 72;
            this.initialWidth = imgWidth;
            this.initialHeight = imgHeight;
            setWidth(this.photoContainerDom, this.initialWidth);
            setHeight(this.photoContainerDom, this.initialHeight);
            setWidth(this.containerParent, this.initialWidth);

            this.containerParent.style.left = containerleft + 'px';
            this.leftBtn.style.left = leftBtnLeft + 'px';
            this.rightBtn.style.right = leftBtnLeft + 'px';
            this.arrowContainer[0].style.top = leftBtnTop + 'px';
            this.arrowContainer[1].style.top = leftBtnTop + 'px';
            this.zoomBtn.style.top = zoomBtnTop + 'px';
        }
        PhotoGallery.prototype.init = function (setting) {

            if (this.inited) {
                console.error('already inited');
                return;
            }
            var setting = setting || {};

            if (setting.onClose) {
                this.onClose = setting.onClose;
            }
            if (setting.onOpen) {
                this.onOpen = setting.onOpen;
            }
            this.onOpen();
            this.show();
            this.drawBack();
            this.initPhotos();
            this.bindClick();
            this.bindCustomEvent();
            this.bindWindowResize();
            this.bindKeyboardControll();
            this.draw();
            this.inited = true;

        };
        PhotoGallery.prototype.initPhotos = function () {
            for (var i = 0; i < this.photoLength; i++) {
                this.photos.push(new Photo(this.data[i], this.photoDom, this.photoContainerDom, this))
            }
            makeInvisible(this.leftBtn, this.photoLength);
            makeInvisible(this.rightBtn, this.photoLength);
            this.currentPhoto = this.photos[this.index];
            this.previousPhoto = this.photos[this.getIndex('prev')];
            this.nextPhoto = this.photos[this.getIndex('next')];
        };
        PhotoGallery.prototype.bindClick = function () {
            var self = this;
            PhotoGalleryDestroy = self.destroy.bind(self);
            PhotoGalleryPrev = self.prev.bind(self);
            PhotoGalleryNext = self.next.bind(self);
            PhotoGalleryZoomIn = function () {
                self.currentPhoto.zoomIn();
            };
            PhotoGalleryZoomOut = function () {
                self.currentPhoto.zoomOut();
            };

            this.closeBtn.addEventListener('click', PhotoGalleryDestroy);
            this.leftBtn.addEventListener('click', PhotoGalleryPrev);
            this.rightBtn.addEventListener('click', PhotoGalleryNext);
            this.zoomInBtn.addEventListener('click', PhotoGalleryZoomIn);
            this.zoomOutBtn.addEventListener('click', PhotoGalleryZoomOut);
            //this.downloadBtn.addEventListener('click', self.currentPhoto.download);
        };

        PhotoGallery.prototype.destroy = function () {
            for (var i = 0; i < this.photos.length; i++) {
                if (this.photos[i].inited) {
                    this.photos[i].destroy();
                }
            }
            this.unbindKeyboardControll();
            this.hide();

            this.closeBtn.removeEventListener('click', PhotoGalleryDestroy);
            this.leftBtn.removeEventListener('click', PhotoGalleryPrev);
            this.rightBtn.removeEventListener('click', PhotoGalleryNext);
            this.zoomInBtn.removeEventListener('click', PhotoGalleryZoomIn);
            this.zoomOutBtn.removeEventListener('click', PhotoGalleryZoomOut);
            this.dom.removeEventListener('photoChanged', PhotoGalleryPhotoChanged);
            this.dom.removeEventListener('windowResize', PhotoGalleryWindowResize);
            window.removeEventListener('resize', PhotoGalleryResize);
        };
        PhotoGallery.prototype.show = function () {
            showDom(this.dom);
            this.onOpen();
        };
        PhotoGallery.prototype.hide = function () {
            hideDom(this.dom);
            this.onClose();
        };
        PhotoGallery.prototype.next = function () {
            this.index = this.getIndex('next');

            this.currentPhoto = this.photos[this.index];
            this.previousPhoto = this.photos[this.getIndex('prev')];
            this.nextPhoto = this.photos[this.getIndex('next')];
            this.trigger('photoChanged');
        };
        PhotoGallery.prototype.prev = function () {
            this.index = this.getIndex('prev');
            this.currentPhoto = this.photos[this.index];
            this.previousPhoto = this.photos[this.getIndex('prev')];
            this.nextPhoto = this.photos[this.getIndex('next')];
            this.trigger('photoChanged');
        };
        PhotoGallery.prototype.drawPhoto = function () {
            this.currentPhoto.init();
            this.previousPhoto.preload();
            this.nextPhoto.preload();
        };
        PhotoGallery.prototype.trigger = function (eventName) {
            this.dom.dispatchEvent(this.eventMapping[eventName]);
        };
        PhotoGallery.prototype.bindCustomEvent = function () {
            PhotoGalleryPhotoChanged = this.draw.bind(this);
            var self = this;
            PhotoGalleryWindowResize = function () {
                self.drawBack();
                self.currentPhoto.resize();
            }
            self.dom.addEventListener('photoChanged', PhotoGalleryPhotoChanged);
            self.dom.addEventListener('windowResize', PhotoGalleryWindowResize);
        };
        PhotoGallery.prototype.bindWindowResize = function () {
            var timer;
            var self = this;
            PhotoGalleryResize = function () {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    self.trigger('windowResize');
                }, 40);
            };
            window.addEventListener('resize', PhotoGalleryResize);
        };
        PhotoGallery.prototype.bindKeyboardControll = function () {
            var self = this;
            Keyboard.bind('←', self.prev.bind(self));
            Keyboard.bind('→', self.next.bind(self));
            Keyboard.bind('esc', self.destroy.bind(self));
        };
        PhotoGallery.prototype.unbindKeyboardControll = function () {

            Keyboard.unbind('←', '→', 'esc');
        };
        PhotoGallery.prototype.drawText = function () {

            if (!this.currentPhoto.title) {
                setDisplay(this.notitle, 'block');
                setDisplay(this.onlytitle, 'none');
                setDisplay(this.titledescrip, 'none');
                this.indexDom[0].innerHTML = this.index + 1 + '/' + this.photoLength;
            }

            if (this.currentPhoto.title && !this.currentPhoto.description) {
                 setDisplay(this.onlytitle, 'block');
                 setDisplay(this.notitle, 'none');
                 setDisplay(this.titledescrip, 'none');
                 this.indexDom[1].innerHTML = this.index + 1 + '/' + this.photoLength;
                 this.photoNameDom[0].innerHTML = this.currentPhoto.title || '';
                 if (this.currentPhoto.iconurl) {
                     this.littleTag[0].src = this.currentPhoto.iconurl;
                     setDisplay(this.littleTag[0], 'block');
                     setHeight(this.littleTag[0], 20);
                     setWidth(this.littleTag[0], 20);
                  } else {
                      setDisplay(this.littleTag[0], 'none');
                    //   this.littleTagContainer[0].style.marginLeft = '0px';
                  }
            }

            if (this.currentPhoto.title && this.currentPhoto.description) {
                 setDisplay(this.titledescrip, 'block');
                 setDisplay(this.notitle, 'none');
                 setDisplay(this.onlytitle, 'none');
                 this.indexDom[2].innerHTML = this.index + 1 + '/' + this.photoLength;
                 this.photoNameDom[1].innerHTML = this.currentPhoto.title || '';
                 this.photoDescription.innerHTML = this.currentPhoto.description;
                 if (this.currentPhoto.iconurl) {
                     this.littleTag[1].src = this.currentPhoto.iconurl;
                     setDisplay(this.littleTag[1], 'block');
                     setHeight(this.littleTag[1], 20);
                     setWidth(this.littleTag[1], 20);
                 } else {
                     setDisplay(this.littleTag[1], 'none');
                    //   this.littleTagContainer[1].style.marginLeft = '0px';
                 }
            }

        };
        PhotoGallery.prototype.draw = function () {
            this.drawText();
            this.drawPhoto();
        };

        return PhotoGallery;
    })();
    return PhotoGallery;
};



//////////////////
// WEBPACK FOOTER
// ./~/@souche-vue/sue-pc/src/components/photogallery/dc-photoGallery/main.js
// module id = 288
// module chunks = 4